export default {
  guestName: 'there',
  memberSince: 'Member since {date}',

  verifyEmail: {
    title: 'Verify your email to start purchasing',
    sentTo: 'We sent a link to',
    sent: '· Verification email sent!',
    unavailable: '· Could not send. Try again or contact support.',
    resend: 'Resend verification email',
    emailSent: 'Email sent',
  },

  access: {
    title: 'Purchase access',
    emailVerified: 'Email verified',
    emailNotVerified: 'Email not verified',
    kycApproved: 'KYC approved',
    kycPending: 'KYC pending review',
    kycNotVerified: 'KYC not verified',
    kycRequired: 'Required for purchases over €50',
  },

  wallet: {
    balance: 'Wallet balance',
    held: 'on hold',
    topUp: 'Top up',
  },

  lastOrder: {
    title: 'Last order',
    none: 'No orders yet.',
    browse: 'Browse catalog',
  },

  wishlist: {
    title: 'Wishlist',
    // vue-i18n plural (en rule): one | other
    saved: '{count} game saved | {count} games saved',
  },

  orders: {
    label: 'Orders',
  },

  quickLinks: {
    catalog: 'Browse',
    help: 'Help',
  },
};
